import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=b46ea9f4&"
import script from "./TeamForm.vue?vue&type=script&lang=js&"
export * from "./TeamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports